const Rules = {
  required: (value) => !!value || 'This information is requried',
  LastNameRequired: (value) => !!value || 'Last name is required.',
  LastNamePattern: (value) => {
    const pattern = /[A-Za-z]/
    return pattern.test(value) || 'Invalid name.'
  },
  FirstNameRequired: (value) => !!value || 'First name is required.',
  FirstNamePattern: (value) => {
    const pattern = /[A-Za-z]/
    return pattern.test(value) || 'Invalid name.'
  },

  DOBrequired: (value) => !!value || 'Date Of Birth is required',

  USCitizen: (value) => value != null || 'Please indicate if you are a US Citizen',

  RAddressLine1: (value) => !!value || 'Residential Address is required.',
  RCityrequired: (value) => !!value || 'Residential City is required.',
  RCountyrequired: (value) => !!value || 'Residential County is required.',
  RStaterequired: (value) => !!value || 'Residential State is required.',
  RZiprequired: (value) => !!value || 'Residential ZipCode is required.',

  MAddressLine1: (value) => !!value || 'Mailing Address is required.',
  MCityrequired: (value) => !!value || 'Mailing City is required.',
  MCountyrequired: (value) => !!value || 'Mailing County is required.',
  MStaterequired: (value) => !!value || 'Mailing State is required.',
  MZiprequired: (value) => !!value || 'Mailing ZipCode is required.',

  HomePhone: (value) => !!value || 'Home Phone is required.',
  WorkPhone: (value) => !!value || 'Work Phone is required.',
  CellPhone: (value) => !!value || 'Cell Phone is required.',

  personalemailRequired: (value) => !!value || 'Personal Email Is Required',
  personalemailPattern: (value) => {
    const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    return pattern.test(value) || 'Email is not in correct format'
  },
  workemailRequired: (value) => !!value || 'Work Email Is Required',
  workEmailPattern: (value) => {
    const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    return pattern.test(value) || 'Email is not in correct format'
  },

  ProfessionandSpecialtyRequired: (value) =>
    !!value || 'Please select Your Profession',

  //some professions doesn't have specialty
  SpecialtyRequired: (value) => !!value || 'Please select Your Specialty',

  RaceRequired: (value) => !!value || 'Please select your Race',

  EthinicityRequired: (value) => !!value || 'Please select Ethinicity',

  GenderRequired: (value) => !!value || 'Please select Your Gender',

  AreYouFluentInEnglishRequired: (value) =>
  value != null || 'Please indicate if you are fluent in languages other than English',

  SelectYesinFluent: (value) => !!value || 'This information is requried',

  ExperienceOrTrainiginMultiCulturalRequired: (value) =>
  value != null  ||
    'Please indicate if you have experience or training in multicultural settings or serving populations with special needs',
  SelectYesinFexperience: (value) => !!value || 'This information is requried',

  RuralORMediUnderserveredAreaRequired: (value) =>  value != null ||    'Please indicate if you are you a native of a rural or medically underserved area',

  SelectYesinRural: (value) => !!value || 'This information is requried',

  DoproviderSubusedisordertreatment:(value)=>  value != null ||    'Do you provider Sub used is order treatment',

  DoyouhaveSUDlicenseorcertificate:(value)=>  value != null ||    'Do you have SUD license or certificate',

  DoyouhaveaDATA2000Waiver:(value)=>  value != null ||    'Do you have a DATA 2000 Waiver',

  IfYesSelectOnofTheDATA2000Waiver:(value)=> value != null ||    'Please select one',

  AreyouatelehealthProvider:(value) =>(value)!=null|| 'Are you a Telehealth Provider',

  ifyeshourstoenter:(value) =>(value)!=null|| 'Please Provide average # of hours provided per week',





  //General Questions
  SelectYesNameOfChild: (value) => !!value || 'This information is requried',
  SelectYesPhoneNumber: (value) => !!value || 'please enter Phone Number',
  SelectYesAdditionalNotes: (value) =>
    !!value || 'Please enter additional notes',

  HaveLicenseEverBeenSuspendedRevoked: (value) =>
  value != null || 'Please indicated if your license has ever been suspended or evoked',

  ProfessionalDispendPendingAgainstYou: (value) =>
  value != null || 'Please indicate if there are any professional disciplinary actions pending against you',

  AnyRestrictionsOnYourLicense: (value) =>
  value != null || 'Please indicate if there are restrictions on your license',

  OriginalLicenseDateRequired: (value) =>
  value != null  || 'Please select Original License Date ',

  HaveYourConvictedoforPledguiltyUnderFederalLaw: (value) =>
  value != null ||
    'Please inidcate if you have even been convicted of or pled guilty for a felony under federal law',

  ObligationNotCompletedWYSLRPService: (value) =>
  value != null || 'Please indicate if you have an existing obligation to WySLRP',

  DefaultAnyEducationalLoans: (value) =>
  value != null || 'Please indicate if you are in default on any existing loans',

  JudgmentLienAgainstPropertyForDebtToUS: (value) =>
  value != null || 'Please indicate if you have ever had a judgment lien against your property for a debt to the US',

  DefaultFederalPayObligations: (value) =>
  value != null || 'Please indicate if you have ever defaulted on a federal payment obligation',

  ReachedPriorServiceObligationToGovOrEntity: (value) =>
  value != null ||
    'Please indicate if you have ever breached a prior service obligation ',

  FederalDebtWrittenOffAsUncollectible: (value) =>
  value != null || 'Please indicate if you have ever had any federal debt written off as uncollectible',

  DoYouUnfulfilledChildSupportObligations: (value) =>
  value != null || 'Please indicate if you have unfulfilled child support obligations',

  //Educational Loans tab
  DefaultAnyEducationalLoans: (value) =>
    value != null || 'Please indicate if you have default on any educational loans',
  Lender: (value) => !!value || 'Lender is required ',
  Balance: (value) => !!value || 'Balance is required ',
  LoansDate: (value) => !!value || 'Loan Date is required ',
  LoanTypeRequired: (value) => !!value || 'Loan type is required',

  TotalEligible: (value) => !!value || 'Total Eligible Debt is required ',
  //Lending insittute

  LendingInsInstitutionName: (value) =>
    !!value || 'Lending Institution Name is required',

  LoanAccountNumber: (value) =>
    !!value || 'Loan Account Number is required',
  Address: (value) => !!value || 'Address is required',
  City: (value) => !!value || 'City is required',
  State: (value) => !!value || 'State is required',

  Zip: (value) => !!value || 'Zip is required ',
  Phone: (value) => !!value || 'Phone is required ',
  Fax: (value) => !!value || 'Fax is required ',
  Email: (value) => !!value || 'Email is required ',
  County: (value) => !!value || 'County is required ',

  NumLoans: (list) => {
    let num = 0
    list.forEach(l => {
      if(l.WasTheLoanSold){
        num++
      }
    })
    if(list.length > num){
      return true
    }
    return 'Please add the information for each additional lender a loan was sold to'
  },
  //Licensure

  LicenseTypeRequired: (value) => !!value || 'License Type is required.',
  LicenseNumberRequired: (value) => !!value || 'License Number is required.',
  DisciplineOrSpecialtyRequired: (value) =>
    !!value || 'Discipline/Specialty is required.',
  OriginalLicenseDateRequired: (value) =>
    !!value || 'Original License Date is required',

  LicenseDateCheck: (orignalDate, expirDate) =>
    new Date(orignalDate) < new Date(expirDate) ||
    'Original Date should come before Expiration Date',
  LicenseExpirationDateRequired: (value) =>
    !!value || 'License Expiration Date is required',

  RestrictionsRequired: (value) => !!value || 'Information required, type N/A if there are no restrictions',
  LicensingAgencyOfBoardRequired: (value) =>
    !!value || 'Licensing Agency or Board is required',
    // AreyouCurrentlyLiceinWy:(value)=>
    // !!value|| 'please select Are You Currently Licensed In WY',

  NotLicensedequired: (value) =>
    !!value || 'Information required, type when your licensed will be obtained',

  //Education

  SchoolName: (value) => !!value || ' Name is required',
  Degree: (value) => !!value || ' Degree is required',
  Date: (value) => !!value || ' Degree Date is required',
  City: (value) => !!value || ' City is required',
  State: (value) => !!value || 'State is required',

  DateRequired: (value) => !!value || 'Date field is required',
  EduDateCheck: (startDate, endDate) => {
    if(startDate != null  && endDate != null){
      return new Date(startDate) < new Date(endDate) || 'Start Date should come before End Date'
    } else {
      return true
    }
  },

  //Lending insitution

  IsThisaConsolidatedLoan: (value) =>
    value != null || 'Please indicate if this loan is consolidated ',
  AcademicPeriodCoveredByLoan: (value) =>
    !!value || ' Academic Period Covered By Loan is required',
  OriginalLoanAmount: (value) => !!value || ' Original Loan Amount is required',
  CurrentLoanPAndIBalance: (value) =>
    !!value || ' Current Loan PA nd I Balance is required',
  InterestRate: (value) => {
    const pattern = /[0-9]{1,2}\.?([0-9]{1,2})?%?/
    return (!!value && pattern.test(value)) || 'Interest Rate must be formatted as a percentage'
  },

  PurposerOfLoanIndicatedOnApplication: (value) =>
    !!value || ' Purpose Of Loan Indicated On Application is required',
  WasTheLoanSold: (value) => value != null || ' Please indicate if this loan was sold',
  IstheLoaninDefault: (value) =>
    value != null || 'Please indicate if this loan is in default',
  IstheLoanUnderFederalCourtJudgement: (value) =>
    value != null || 'Please indicate if this loan is under federal court judgement',
  State: (value) => !!value || 'State is required',


  //Practice Site
  FEIN: (value) => !!value || ' FEIN is required',
  NationalHSCorpsSiteApprovalDate: (value) =>
    !!value || ' National HSCorps Site Approval Date is required',
  DoesitAcceptAllPatientsRegardInsuranceorAbilitytoPay: (value) =>
    value !=null || 'Accept All Patients is required',
    IfNoDetailedInformation: (value) =>
    !!value || ' If No Detailed Information is required',

  PublicEntity: (value) => value != null || 'Public Entity is required',

  IfYesPublicEntity: (value) => !!value || ' If Yes Public Entity is required',
  PrivateNotforProfit: (value) => value != null || ' Private Not for Profit is required',
  IfYesTypeOfPracticePrivateNonProfit: (value) => 
    !!value || 'Type Of Practice Private Non Profit is required',
  HPSADesignationID: (value) => !!value || ' HPSA Designation ID is required',
  DesignationType: (value) => value != null || 'Please select Designation Type',



  AdditionalNationalHealthServiceCorpsSite: (value) => value != null || 'Please indicate whether additional National Health Service Corps Sites approved or not',
  
  NHSRequired: (value) => !!value || 'This information is required',
  NationalHealthServiceDateCheck: (orignalDate, expirDate) =>
    new Date(orignalDate) < new Date(expirDate) ||
    'Approval Date should come before Expiration Date',

      
  SCRequired: (value) => !!value || 'This information is required',

    ServiceComplianceDateCheck: (orignalDate, expirDate) =>
    new Date(orignalDate) < new Date(expirDate) ||
    'From Date should come before through Date',

  HPSAScore: (value) => !!value || 'HPSA Score is required',
  AnyLimitToPatinetsSiteAccepts: (value) =>
  value != null || 'Please indicate if there are any limits on patients the healthcare provider or practice site accepts',
  IfYesExplainSiteAccepts: (value) =>
    !!value || 'This information is required',
  DoesAcceptMedicareAssignment: (value) =>
  value != null || 'Please indicate if the site accepts Medicare',
  IfYesExplainMedicareAssignment: (value) =>
    !!value || 'This information is required',

  DoesHCPSiteAcceptsMedicacisKidChipPatients: (value) =>
  value != null || 'Please indicate if the site accepts Medicaid/KidCare CHIP',
  IfNoHCPSiteAcceptsMedicacisKidChipPatientsDetails: (value) =>
    !!value || 'This information is required',
  ListPracticeSiteBoundaries: (value) =>
    !!value || 'List Practice Site Boundariesis required',
  TotalNoOfFullTimeEquEmployedinthePracticeSite: (value) =>
    !!value || 'Total Number Of FTE Providers  is required',
  TotalNumberOfActivePatients: (value) =>
    !!value || 'Total Number Of Active Patients is required',
  ListAnyIndicatorsOfUnusuallyHighNeeds: (value) =>
    !!value || 'This information is required',

  weekleydaywork: (value) => !!value || 'Weekley day work hours is required',
  // employment
  HCProvideServiceatMultipleLocation: (value) =>
    value !=null || 'Please indicate if you serve at multiple locations',
  HCProvideSpecialCareAtPracticeSite: (value) =>
    value !=null || 'Please indicate if you provide special care at this practice site',
  IfYesExplainAdditionalPracticeSites: (value) =>
    !!value || 'This information is required',
  IfYesHCProvideSpeacialCareAtSite: (value) =>
    !!value || 'This information is required',
  ProposedSalary: (value) => !!value || 'Proposed Salary is required',
  NumberOnly: (value) => {
    const pattern = /^\d+$/
    return pattern.test(value) || 'Value must be numeric'
  },
  BenefitsMalPracticeCoverage: (value) =>
    !!value || 'This information is required',
  ReduceTheCompensationAsaResultOfWYSLRP: (value) =>
    value !=null || 'Reduce The Compensation As a Result Of WYSLRP is required',
  AggrementbtSiteAndHCBonusPay: (value) =>
    value != null || 'Bonus payments is required',
  SitePlanAreaUponCompletiontoWYSLRP: (value) =>
    !!value || 'This information is required',

  Recritmentlastthreemonths :(value) => value != null || 'Please indicate if you have been recruited in the last three months',
  RetentionExisitngStaff :(value) => value != null || 'Please indicate if you are an existing employee',

}
export default Rules
